var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"BlockButton"},[_c('a',{staticClass:"BlockButton-Button",style:(_vm.style),attrs:{"href":_vm.link,"target":_vm.link ? "_blank" : false},domProps:{"innerHTML":_vm._s(_vm.text)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }